import { render, staticRenderFns } from "./MyShare.vue?vue&type=template&id=86fa8f5a&scoped=true&"
import script from "./MyShare.vue?vue&type=script&lang=js&"
export * from "./MyShare.vue?vue&type=script&lang=js&"
import style0 from "./MyShare.vue?vue&type=style&index=0&id=86fa8f5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86fa8f5a",
  null
  
)

export default component.exports